import { ReactElement, useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import Form, { GroupItem, SimpleItem } from "devextreme-react/form";
import {
    Label,
    RequiredRule,
} from "devextreme-react/form";
import { getLocalized } from '../../../../../redux/localization';
import { DropDownGrid, FileUploader, Modal } from '../../../../../components';
import { AccountProduct, Category, Currency, FakeCategory, Periods, ProductRates, SubCategories } from './type';
import { Button, DataGrid } from 'devextreme-react';
import { useHistory, useParams } from 'react-router-dom';
import { ApiResponse, verfiyResponse } from '../../../../../redux/base/types/saga';
import { BodyType, createRequest } from '../../../../../redux/base/request';
import { getApiParams } from '../../../../../redux/auth';
import { DropDownOptions } from 'devextreme-react/drop-down-box';
import notify from 'devextreme/ui/notify';
import { ProductFeatures } from '../../../../productFeatures/type';
import { NewPriceForm } from './newPrice';



export const renderInformationItem = (item: any) => {
    if (item.editorOptions.value !== null) {
        return <span>{item.editorOptions.value}</span>;
    } else {
        return <span>-</span>;
    }
};

const CreateAccountProductForm = () => {
    const { Id }: { Id: string } = useParams();
    const data = useRef<AccountProduct>({
        AccountId: Id,
        CategoryId: "",
        Images: [],
        PeriodId: 0,
        CurrencyId: 0,
        Price: 0,
        Deposit: 0,
        MinimumRentDay: 0,
        MaximumRentDay: 0,
        MinimumNoticeDay: 0,
        Insurance: false,
        OnlyConfirmateUser: false,
        Name: "",
        Description: "",
        AccountStorageId: "",
        Translate: [],
        ProductItemSerialNumbers: [],
        ProductFeatureItems: [],
        Rates: []
    });
    const localize = useSelector(getLocalized);
    const [subCategories, setSubCategories] = useState<SubCategories[]>([])
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([]);
    const [currency, setCurrency] = useState<Currency[]>([])
    const [storage, setStorage] = useState<Storage[]>([])
    const [periods, setPeriods] = useState<Periods[]>([])
    const [show, setShow] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [productFeatures, setProductFeatures] = useState<ProductFeatures[]>([])
    const { token, lang } = useSelector(getApiParams);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [components, setComponents] = useState<ReactElement[]>();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [components1, setComponents1] = useState<ReactElement[]>();
    const [, setId] = useState("");
    const [, setId1] = useState("");
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [, setId2] = useState("");
    //data type oluşturuldu SimpleItemlara eklenecek
    const ref1 = useRef<any>();

    const fakeCategory = useRef<FakeCategory>({
        CategoryId: ""
    })

    const ProductRates = useRef<ProductRates>({
        StartDate: new Date(),
        EndDate: new Date(),
        MinimumRent: 0,
        MaximumRent: 0,
        Price: 0,

    });

    const getProductFeatures = useCallback((async () => {
        const response: ApiResponse<ProductFeatures[]> = await createRequest({
            method: "GET",
            url: "/api/admin/productfeatures",
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setProductFeatures(response.Result)
        }
    }), [token, lang])
    const getCategories = useCallback((async () => {
        const response: ApiResponse<Category[]> = await createRequest({
            method: "GET",
            url: "/api/dashboardview/categories",
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setCategories(response.Result)
        }
    }), [token, lang])
    const getCurrency = useCallback((
        async () => {
            const response: ApiResponse<Currency[]> = await createRequest({
                method: "GET",
                url: "/api/system/currencies",
                bodyType: BodyType.formdata,
                token,
                body: {},
                lang,
            });
            if (verfiyResponse(response)) {
                setCurrency(response.Result)
            }
        }
    ), [token, lang])
    const getPeriods = useCallback((async () => {
        const response: ApiResponse<Periods[]> = await createRequest({
            method: "GET",
            url: "/api/product/periods",
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setPeriods(response.Result)
        }
    }), [lang, token])

    const getStorage = useCallback((async () => {
        const response: ApiResponse<Storage[]> = await createRequest({
            method: "GET",
            url: "/api/admin/accounts/get-account-storages/" + Id,
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setStorage(response.Result)

        }
    }
    ), [token, lang, Id])

    const getSubCategories = useCallback((async (id: any) => {
        const response: ApiResponse<SubCategories[]> = await createRequest({
            method: "GET",
            url: "/api/dashboardview/categories/" + id,
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setSubCategories(response.Result)
        }
    }), [token, lang])
    useEffect(() => {
        getCategories()
        getCurrency()
        getPeriods()
        getStorage()
        getProductFeatures()
    }, [getCategories, getCurrency, getPeriods, getStorage, getProductFeatures])


    return (
        <form>
            <p style={{
                fontSize: "24px",
                fontWeight: 600,
                padding: "15px 0px"
            }}>Hesap Ürün Ekleme Formu</p>
            <Form

                key="id"
                labelLocation="left"
                formData={data.current}
                showColonAfterLabel={true}

            >
                <GroupItem colCount={1}>
                    <GroupItem colCount={2}>
                        <SimpleItem
                            dataField={"Name"}
                            editorType={"dxTextBox"}

                            label={{ text: localize.getString("name") }}
                        >
                            <Label visible={false} />
                            <RequiredRule message={localize.getString("required")} />
                        </SimpleItem>
                        <SimpleItem
                            dataField={"Description"}
                            editorType={"dxTextArea"}
                            editorOptions={{
                                inputAttr: {
                                    style: "height : 250px "

                                },

                            }}
                            label={{ text: localize.getString("description") }}
                        >
                            <Label visible={false} />
                            <RequiredRule message={localize.getString("required")} />
                        </SimpleItem>
                        <SimpleItem
                            dataField={"Price"}
                            editorType={"dxTextBox"}

                            label={{ text: localize.getString("price") }}
                        >
                            <RequiredRule message={localize.getString("required")} />
                        </SimpleItem>
                        <SimpleItem
                            dataField={"Deposit"}
                            editorType={"dxTextBox"}
                            editorOptions={{
                                inputAttr: {
                                    style: " text-transform: capitalize",
                                },
                            }}
                            label={{ text: localize.getString("deposit") }}
                        >
                            <RequiredRule message={localize.getString("required")} />
                        </SimpleItem>
                        <SimpleItem
                            dataField={"MinimumRentDay"}
                            editorType={"dxTextBox"}
                            editorOptions={{
                                inputAttr: {
                                    style: " text-transform: capitalize",
                                },
                            }}
                            label={{ text: localize.getString("minimumRentDay") }}
                        >
                            <RequiredRule message={localize.getString("required")} />
                        </SimpleItem>
                        <SimpleItem
                            dataField={"MaximumRentDay"}
                            editorType={"dxTextBox"}
                            editorOptions={{
                                inputAttr: {
                                    style: " text-transform: capitalize",
                                },
                            }}
                            label={{ text: localize.getString("maximumRentDay") }}
                        >
                            <RequiredRule message={localize.getString("required")} />
                        </SimpleItem>
                        <SimpleItem
                            dataField={"MinimumNoticeDay"}
                            editorType={"dxTextBox"}
                            editorOptions={{
                                inputAttr: {
                                    style: " text-transform: capitalize",
                                },
                            }}
                            label={{ text: localize.getString("minimumNoticeDay") }}
                        >
                            <RequiredRule message={localize.getString("required")} />
                        </SimpleItem>
                        <SimpleItem
                            dataField={"Insurance"}

                            editorType={"dxCheckBox"}
                            label={{ text: localize.getString("insurance") }}
                        >
                            <RequiredRule message={localize.getString("required")} />
                        </SimpleItem>
                        <SimpleItem
                            dataField={"OnlyConfirmateUser"}

                            editorType={"dxCheckBox"}
                            label={{ text: localize.getString("onlyConfirmateUser") }}
                        >
                            <RequiredRule message={localize.getString("required")} />
                        </SimpleItem>
                        <SimpleItem
                            dataField={`Image[0].Document`}
                            label={{
                                text: localize.getString("image")
                            }}
                        >
                            <FileUploader
                                buttonText={localize.getString("addImage")}
                                onValueChanged={(values) => (data.current.Images = values)}
                            />
                            <RequiredRule message={localize.getString("required")} />
                        </SimpleItem>
                        <SimpleItem
                            dataField="ParentCategoryId"
                            editorType="dxLookup"
                            label={{ text: localize.getString("category") }}
                            render={(item: any) => (
                                <DropDownGrid
                                    dataSource={categories}
                                    columns={["ParentCategoryName", "Name", "Order"]}
                                    displayExpr="Name"
                                    returnSelectedId={async (id: any) => {
                                        item.editorOptions.value = id;

                                        //data.current.CategoryId = id;
                                        fakeCategory.current.CategoryId = id
                                        console.log(id)
                                        getSubCategories(id)
                                        setId(id);
                                    }}
                                    value={fakeCategory.current.CategoryId}
                                    dropDownOptions={{ width: 900 }} />
                            )}
                        >
                            <RequiredRule message={localize.getString("required")} />
                            <DropDownOptions closeOnOutsideClick showTitle={false} />
                        </SimpleItem>
                        <SimpleItem
                            dataField="ParentCategoryId"
                            editorType="dxLookup"
                            label={{ text: localize.getString("subCategory") }}
                            render={(item: any) => (
                                <DropDownGrid
                                    dataSource={subCategories}
                                    columns={["ParentCategoryName", "Name", "Order"]}
                                    displayExpr="Name"
                                    returnSelectedId={async (id: any) => {
                                        item.editorOptions.value = id
                                        data.current.CategoryId = id
                                        console.log(id)
                                        setId1(id);
                                    }}

                                    value={data.current.CategoryId}
                                    dropDownOptions={{ width: 900 }}
                                />
                            )}
                        >
                            <DropDownOptions closeOnOutsideClick showTitle={false} />
                        </SimpleItem>
                        <SimpleItem
                            dataField={`PeriodId`}
                            label={{
                                text: localize.getString("period"),
                            }}
                            editorType={"dxLookup"}
                            editorOptions={
                                {
                                    searchEnabled: true,
                                    items: periods,
                                    displayExpr: "Name",
                                    valueExpr: "Id",
                                }
                            }
                        >
                            <RequiredRule message={localize.getString("required")} />
                        </SimpleItem>
                        <SimpleItem
                            dataField={`CurrencyId`}
                            label={{
                                text: localize.getString("currency"),
                            }}
                            editorType={"dxLookup"}
                            editorOptions={
                                {
                                    searchEnabled: true,
                                    items: currency,
                                    displayExpr: "Name",
                                    valueExpr: "EnumId",
                                }
                            }
                        >
                            <RequiredRule message={localize.getString("required")} />
                        </SimpleItem>
                        <SimpleItem
                            dataField={`AccountStorageId`}
                            label={{
                                text: localize.getString("accountStorage"),
                            }}
                            editorType={"dxLookup"}
                            editorOptions={
                                {
                                    searchEnabled: true,
                                    items: storage,
                                    displayExpr: "LocationTitle",
                                    valueExpr: "Id",
                                }
                            }
                        >
                            <RequiredRule message={localize.getString("required")} />
                        </SimpleItem>

                    </GroupItem>
                    <GroupItem>

                        <SimpleItem>
                            <Button
                                type='success'
                                text='Yeni Fiyat Ekle'
                                onClick={() => {

                                    setShow(true)
                                }}
                            >

                            </Button>
                        </SimpleItem>

                        <SimpleItem

                        >
                            <Modal
                                visible={show}
                                onHiding={() => { setShow(false) }}
                                title={localize.getString("addNewPrice")}
                                width="50%"
                                height="50%"
                                onSubmitClick={async () => {


                                    console.log(ProductRates.current)
                                    data.current.Rates.push({
                                        EndDate: ProductRates.current.EndDate,
                                        MaximumRent: ProductRates.current.MaximumRent,
                                        MinimumRent: ProductRates.current.MinimumRent,
                                        Price: ProductRates.current.Price,
                                        StartDate: ProductRates.current.StartDate
                                    })
                                    
                                    ref1.current.instance.resetValues();
                                    console.log(data.current.Rates)
                                    setShow(false)

                                }}>
                                <NewPriceForm data={ProductRates.current} ref={ref1}></NewPriceForm>
                            </Modal>
                        </SimpleItem>
                    </GroupItem>
                    <GroupItem>
                        <SimpleItem

                        >
                            <DataGrid
                                dataSource={data.current.Rates}
                                columns={["Price"]}
                            >

                            </DataGrid>
                        </SimpleItem>
                    </GroupItem>
                </GroupItem>

            </Form>
            
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    marginBlockStart: 15,
                }}
            >
                <Button
                    width={120}
                    style={{
                        marginRight: "15px"
                    }}
                    text={localize.getString("save")}
                    type="success"
                    stylingMode="contained"
                    onClick={async () => {
                        
                        
                        if (data.current.CategoryId !== "") {
                            console.log(data.current.CategoryId, "1")
                        } else {
                            data.current.CategoryId = fakeCategory.current.CategoryId
                            console.log(data.current.CategoryId, "2")
                        }
                        const response: ApiResponse<AccountProduct> = await createRequest({
                            method: "POST",
                            url: "/api/admin/products/add-product",
                            bodyType: BodyType.formdata,
                            token,
                            body: data.current,
                            lang,
                        });
                        if (response.Status === 1) {
                            notify(response.Message, "success")
                        }
                        else if (response.Status !== 1)
                            notify(response.Message, "error")
                    }
                    }
                />
                <Button
                    width={120}
                    text={localize.getString("close")}
                    type="default"
                    stylingMode="contained"
                    onClick={() => { history.goBack() }}
                />
            </div>
        </form>
    );
}


export default CreateAccountProductForm;


